import styled, { device, color, createGlobalStyle } from '@styled'
import { Col } from '@ui/wrapper'

export const SectionWrapper = styled.section`
  padding-block-start: 50px;
  padding-block-end: 60px;
  ${device.medium} {
    padding-block-start: 60px;
    padding-block-end: 80px;
  }
  ${device.large} {
    padding-block-start: 70px;
    padding-block-end: 100px;
  }
  ${color}
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`

export const StyledText2 = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  ${device.medium} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  ${device.large} {
    margin-inline-start: 200px;
    margin-inline-end: 200px;
  }
  ${device.xlarge} {
    margin-inline-start: 230px;
    margin-inline-end: 230px;
  }
  ${device.xxlarge} {
    margin-inline-start: 260px;
    margin-inline-end: 260px;
  }
`

export const StyledContent = styled.p`
  margin-block-start: 15px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`

export const OwnCol = styled(Col)`
  font-size: 18px;
  padding-left: 60px;
  padding-right: 60px;
  display: block;
  align-items: center;
  justify-content: center;
  ${device.small} {
    display: flex;
  }
`

export const ImgDiv = styled.div`
  min-width: 100px;
  margin-right: 30px;
  margin-bottom: 10px;
  ${device.small} {
    margin-bottom: 0px;
  }
`

export const GlobalStyle = createGlobalStyle`
  .own-swiper-slide {
    .swiper-slide {
      opacity: 1 !important;
    }

    .swiper-slide-visible {
      opacity: 1 !important;
    }
  }

  .custom-modal .modal-content {
    background-color: rgb(0 0 0 / 60%);
    border: none;
  }

  .own-background {
    opacity: 1 !important;
    background-color: #b55a30;
  }

  .own-background:hover {
    background-color: rgb(206 153 130);
  }
`

export const SwiperWrapper = styled.div``

export const SlideItemWrapper = styled.div`
  width: ${(props) => props.width}px;
  height: 300px;
  border: none;
  padding: 0;
  background: none;
  font: inherit;
  display: block;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  cursor: pointer;
  opacity: 1;
  &:hover {
    opacity: 0.5;
  }
`

export const SlideItemWrapperFull = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;

  img {
    max-width: 100%;
    max-height: 100vh;
    width: auto;
    height: auto;
    object-fit: contain;
  }
`

export const ButtonWrapper = styled.button`
  position: absolute;
  z-index: 1000;
  display: flex;
  color: grey;
  justify-content: center;
  align-items: center;
  background: white;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  box-shadow:
    0 2px 5px 0 rgba(0, 0, 0, 0.26),
    0 2px 10px 0 rgba(0, 0, 0, 0.16);
  font-size: 20px;
  transition:
    box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1),
    background 150ms cubic-bezier(0.4, 0, 0.2, 1),
    color 150ms cubic-bezier(0.4, 0, 0.2, 1);
  right: 0;
  margin-top: 5px;
  transform: translateX(20%) translateY(10%);
  margin-right: 20px;
  top: 0;
  &:hover {
    color: rgb(181 90 48 / 100%);
    box-shadow:
      0 2px 10px 0 rgba(181, 90, 48, 0.26),
      0 2px 15px 0 rgba(181, 90, 48, 0.16);
  }
`
